import {
    UPDATE_OAUTH_ADDRESS, UPDATE_MY_OPEN_INFO
} from "../mutation-types";
import { oauthAddressLoad } from "../../services/api/oauth-address";
// import { myOpenIdLoad } from "../../services/api";
import { OAUTH_NAME_WEIBO, OAUTH_PLAT_WEIBO } from "../../common/const";
import { oauthBindListLoad } from "../../services/api/oauth-bind-list";
import { find } from "../../common/utils";

export async function loadOauthAddress({
    state,
    commit
}) {
    const port = location.port != '80' ? ':' + location.port : ''
    const redirectUrl = `https://${location.hostname}${port}${location.pathname}?cId=${state.cId}#match/my/awards`
    const {
        address
    } = await oauthAddressLoad({
        redirectUrl: redirectUrl
    })
    commit(UPDATE_OAUTH_ADDRESS, address)
    return address
}

export async function loadMyOpenId({
    commit
}) {
    // const {cId} = state
    // const {
    //     openId
    // } = await myOpenIdLoad({cId})

    const {bindList} = await oauthBindListLoad()
    const bindInfo = find(bindList, o => o.plat === OAUTH_PLAT_WEIBO)

    const openId = bindInfo ? bindInfo.openId : ''
    const openNick = bindInfo ? bindInfo.nickname : ''
    commit(UPDATE_MY_OPEN_INFO, {openId, openNick})

    // console.log(openId);
    
    return openId
}

export async function goBind({state, dispatch}) {
    if (!state.oauthAddress) {
        await dispatch('loadOauthAddress')
    }
    const {
        oauthAddress
    } = state
    if(oauthAddress && oauthAddress[OAUTH_NAME_WEIBO]) {
        location.href = oauthAddress[OAUTH_NAME_WEIBO]
    }
}
